import { useMemo } from 'react';
import AdvancedFilterButton from '../../../../Overview/Components/Filter/AdvancedFilterButton';
import { useIdentifiedProfileFilters } from '../../../api/useIdentifiedProfiles';
import { useIdentifiedListContext } from '../utils/IdentifiedListContext';
import UIStrings from '@/Utils/UIStrings';

const CompanyNameFilter = () => {
    const { options, setOptions } = useIdentifiedListContext();
    const { data } = useIdentifiedProfileFilters();
    const resetCallback = () => setOptions((p) => ({ ...p, companyId: undefined }));

    const menuItems = useMemo<Parameters<typeof AdvancedFilterButton>['0']['menuItems']>(
        () =>
            data?.companies.map(({ id, name, count }) => ({
                id,
                selected: !!options.companyId?.find((selectedCompany) => selectedCompany === id),
                changeCallback: () => {
                    const foundIndex = options.companyId?.findIndex((selectedCompany) => selectedCompany === id);

                    if (typeof foundIndex === 'number' && foundIndex > -1) {
                        setOptions((p) => {
                            const companyId = p.companyId?.toSpliced(foundIndex, 1);
                            return {
                                ...p,
                                companyId: companyId?.length ? companyId : undefined,
                            };
                        });
                    } else {
                        setOptions((p) => ({
                            ...p,
                            companyId: p.companyId?.toSpliced(0, 0, id) || [id],
                        }));
                    }
                },
                menuItemLabel: `${name} (${count})`,
            })) || [],
        [data, options, setOptions],
    );

    return <AdvancedFilterButton label={UIStrings.CompanyName} menuItems={menuItems} resetCallback={resetCallback} />;
};

export default CompanyNameFilter;
